// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.review-star[data-v-17b6313c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.review-star__star[data-v-17b6313c] {\n  color: #E74860;\n  font-size: 20px;\n}\n.review-star__score[data-v-17b6313c] {\n  margin-left: 5px;\n  font-size: 16px;\n}\n.white[data-v-17b6313c] {\n  color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
